export default class Ticket {
    constructor(titulo, descripcion, respuesta, estado) {
      this.titulo = titulo;
      this.descripcion = descripcion;
      this.respuesta = respuesta;
      this.estado = estado;
    }
  }